module.exports = __webpack_public_path__ + "static/img/guide1.adce9be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide1.png
// module id = 6Gti
// module chunks = 2